var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DrawerFooter = void 0;
var DrawerFooter_1 = __importDefault(require("./DrawerFooter"));
exports.DrawerFooter = DrawerFooter_1.default;
exports.default = DrawerFooter_1.default;
//# sourceMappingURL=index.js.map